var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_1168_758)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1168_758",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1168_758",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1168_758",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADS0lEQVR4nO2dz04TURTGRxf+CURdmKgvI76I4isoUR/BxJjwACY8AYJxYVy6EXyARpFNCQnzfacpbRSIyzG31MQQbqHQuaed+/2Ss+2d+/3uDHeY6WlRCCGEEEIIIYQQQggxJv1+/44BTw1YJ7ll5KGRVUPqcDAnYM3KcjHMdWoWSLvdvmHASwL9KQiqSlEkewa82N7evu4afqfTeWDkN+9AzKuATTO77xn+jnsIdK+d5BLCqZf1yueJAjaSXo4MeOU+aU5XkVxKEn7YAYz6g0tgtVOWCwDmioYAYC7MabALikvY7/V6t2s/mMFWM74KnhUNh+RSVILZk9oPIOzzIyv/fZEJ5pkBgZ+nDd4py4dFJnTC5ej0K8BW7YMTOIicfvNFJpjZfOQMOKh/8Mj1r8gM88pBAo6RAGckwBkJcEYCnJEAZyTAGQlwRgKckQBnJMAZCXBGApyRAGckwBkJmABVVV0JlZ2A3d3dmwa8M/LIyC7JNynfqxm81wS8Hb7d8Yfkyrhvccy0gGH41YnnqZ9SSAhjhLFOGX8lCwFVVV2NvTnNmiXEwh/WUTi2xgsIEPgd+xzWJOGM8Md+oD7TAgxYjn2O1SDhrPAHBSxnI+A8gXBCEuoaa6YFBFqt1jUjP44MBvgcvgBy0WOtc4yZF1B3QK2aBTdCQF1BpTi7GiNg0oGlCL9xAiYVXKrwGyngsgGmDL+xAi4aZOrwGy1g3EA9wm+8gHFuoFLd0GUnIHCe1Z165Wcl4DIS6gw/KwEXkVB3+NkJGEdCivCzFHAeCanCz1bAKAkpw89awH9b1NcEykGRr1P37slawDQgAc5IgDMS4IwEOCMBzkiAMxLgjAQ4IwHOSECuAtSyrCi63e6tyH9jf3k27VsoMgHAI7emfdHmpcBakQkGfIicAav1D16Wi+7tex0JbeujT+TMHqdpXRz658cOAlgPp2jTWhcjXHYiKz9p6+IzV0GmxZRtm4df89z0nrRNSRH4Gh6VFikJP1pgZNt78uZfbZL3Cg/29vbukvwyBSFULgVsuP2EyT/CqTds6b7vHgiT1T7J58kvO6MIO4DQPz+0cCf5I3rHPIPF47l8D3MLW81kux0hhBBCCCGEEEIIUTSJv0fbmrMLgvBoAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/Dropdown.b702bf176b12a8334b52ef7403b5fb84.svg";
export { ForwardRef as ReactComponent };